import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyPrimaryData, setFootprintingDairyPrimaryDataAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_PRIMARY_DATA } from "consts";

export const useSubmitFootprintingDairyPrimaryData = (farmId: string, year: number, primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_PRIMARY_DATA, primaryDataId, isAdmin],
      mutationFn: async () =>
        (isAdmin ? setFootprintingDairyPrimaryDataAdmin : setFootprintingDairyPrimaryData)({ farmId, year, isSubmitted: true }, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [...footprintingDairyPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
